// Institutions slice
import { StateCreator, StoreApi } from "zustand";
import { BankInstitution } from "@prisma/client";
import { AppStoreState } from "../appStore";
type SetState = StoreApi<AppStoreState>["setState"];

const createInstitutionsSlice: StateCreator<
  AppStoreState,
  [],
  [],
  Pick<AppStoreState, "institutions" | "setInstitutions">
> = (set: SetState) => ({
  institutions: [],
  setInstitutions: (institutions: BankInstitution[] = []) =>
    set({ institutions }),
});

export default createInstitutionsSlice;
